import { useMutation, useQueryClient } from '@tanstack/react-query';
import { EncounterPhase } from 'src/models';
import { ambientApi } from 'src/services';

export type UseRegenerateEncounterSummaryPayload = {
  encounterId: string;
  encounterPhase: EncounterPhase;
  custom_instructions?: string;
  template_id?: string | null;
  template_overrides_id?: string | null;
  summary_mode?: string;
  summary_verbosity?: string;
  summary_format?: string;
};

export const useRegenerateEncounterSummary = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['regenerateEncounterSummary'],
    mutationFn: ({
      encounterId,
      encounterPhase,
      ...rest
    }: UseRegenerateEncounterSummaryPayload) =>
      ambientApi
        .post(`/encounters/${encounterId}/regenerate_summary`, rest, {
          params: {
            encounter_phase: encounterPhase,
          },
        })
        .then((res) => res.data),
    onSuccess: (_, payload) => {
      queryClient.invalidateQueries({
        queryKey: ['encounterDetails', payload.encounterId],
      });
      queryClient.invalidateQueries({
        queryKey: ['summaryList'],
      });
    },
  });
};
